"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _reactBootstrap = require('react-bootstrap');

var _utils = require('helpers/utils');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ConfirmChangePhoneView: {
        displayName: 'ConfirmChangePhoneView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/ConfirmChangePhone/default/ConfirmChangePhoneView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ConfirmChangePhoneView = _wrapComponent('ConfirmChangePhoneView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(ConfirmChangePhoneView, _Component);

    function ConfirmChangePhoneView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ConfirmChangePhoneView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmChangePhoneView.__proto__ || (0, _getPrototypeOf2.default)(ConfirmChangePhoneView)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
            event.preventDefault();
            _this.props.onSubmit(event);
        }, _this.showAlert = function (alert) {
            var _this$props = _this.props,
                error = _this$props.error,
                errorCode = _this$props.errorCode,
                lang = _this$props.lang;


            if (error) {
                if (errorCode === null || errorCode === undefined) {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang['store.common.server_is_unavailable']
                    );
                } else {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang[error]
                    );
                }
            } else if (_this.props.alert || alert) {
                var _ref2 = _this.props.alert || alert,
                    message = _ref2.message,
                    style = _ref2.style;

                return _react3.default.createElement(
                    _reactBootstrap.Alert,
                    { bsStyle: style || 'danger', className: 'inner-right-xs' },
                    message
                );
            }

            return '';
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ConfirmChangePhoneView, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var lang = this.props.lang;


            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload },
                this.props.outerAlert ? this.showAlert(this.props.outerAlert) : this.showAlert(),
                _react3.default.createElement(
                    'section',
                    { id: 'registration-form' },
                    _react3.default.createElement(
                        'div',
                        { className: 'bordered' },
                        _react3.default.createElement(
                            _reactBootstrap.Form,
                            { onSubmit: this.onSubmit },
                            _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                { controlId: 'sms' },
                                _react3.default.createElement(
                                    _reactBootstrap.ControlLabel,
                                    null,
                                    lang['store.common.enter_sms_code']
                                ),
                                _react3.default.createElement(_reactBootstrap.FormControl, {
                                    type: (0, _utils.isMobileDevice)() ? "number" : "text",
                                    pattern: '\\d*',
                                    placeholder: '1234',
                                    value: this.props.sms,
                                    onChange: function onChange(e) {
                                        if ((0, _utils.validateNumeric)(e.target.value)) {
                                            _this2.props.onChange(e);
                                        }
                                    }
                                })
                            ),
                            _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                null,
                                _react3.default.createElement(
                                    _reactBootstrap.Button,
                                    {
                                        type: 'submit',
                                        className: 'form-control',
                                        bsStyle: 'primary',
                                        disabled: this.props.disabledSubmit
                                    },
                                    lang['store.common.confirm']
                                )
                            ),
                            _react3.default.createElement(_components2.VoiceCode, {
                                login: this.props.login,
                                phone: this.props.phone,
                                source: 'change_phone',
                                showAlert: this.props.showOuterAlert,
                                whiteList: true
                            })
                        )
                    )
                )
            );
        }
    }]);
    return ConfirmChangePhoneView;
}(_react2.Component), _class.propTypes = {
    sms: _react2.PropTypes.string.isRequired,
    onSubmit: _react2.PropTypes.func.isRequired,
    disabledSubmit: _react2.PropTypes.bool.isRequired,
    error: _react2.PropTypes.string,
    lang: _react2.PropTypes.object
}, _temp2));

exports.default = ConfirmChangePhoneView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmChangePhone/default/ConfirmChangePhoneView.jsx
// module id = 1644
// module chunks = 0